import React from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "../../../../components/form/controls/Controls";
import useAuth from "../../../../hooks/useAuth";
import { allowedToCreateEntity } from "../../../../constants/role";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import { isOpenPopup } from "src/utils/isOpenPopup";

const ReFreshControlPanel = ({
  permissionsAccessControl,
  children,
  setOpenPopupChangeKey,
  handleOpenPopupGenerateKey,
}) => {
  const { auth } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <>
            <Controls.Button
              text="Generate Key"
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => handleOpenPopupGenerateKey(isOpenPopup)}
            />

            <Controls.Button
              text="Change Key"
              variant="outlined"
              startIcon={<ChangeCircleOutlinedIcon />}
              onClick={() => {
                setOpenPopupChangeKey(true);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ReFreshControlPanel;
